// extracted by mini-css-extract-plugin
export var title = "PageEventLanding-module--title--Z19eM";
export var wrapper = "PageEventLanding-module--wrapper--0Pn9o";